import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import CourseGeneratorSettings from "../../../components/customCoursework/CourseGeneratorSettings/CourseGeneratorSettings";

interface CourseGeneratorSettingsModalContainerProps {
  visible: boolean;
  onClose: () => void;
  isSubmitting: boolean;
  onGenerateCourse: (numberOfModules: number, numberOfActivities: number, courseDescription: string) => void;
}

const CourseGeneratorSettingsModalContainer = ({
  visible,
  onClose,
  onGenerateCourse,
}: CourseGeneratorSettingsModalContainerProps) => {
  const handleClose = () => {
    onClose();
  };

  const handleGenerateCourse = (data) => {
    onGenerateCourse(data.numberOfModules, data.numberOfActivities, data.courseDescription);
    onClose();
  };

  return (
    <CustomModal visible={visible} onRequestClose={handleClose} showCloseButton={false}>
      <CourseGeneratorSettings onSubmit={handleGenerateCourse} onCancel={handleClose} isSubmitting={false} />
    </CustomModal>
  );
};

export default CourseGeneratorSettingsModalContainer;
